<template>
    <section class="container-record-card">
        <div class="content-text">
            <span class="content-text-title">
                {{ data.title }}
            </span>
            <span class="content-text-desc">
                {{ data.description }}
            </span>
        </div>

        <div class="content-actions">
            <button 
                class="filter-btn" 
                :class="{ 'active': showFilters }" 
                @click="toggleFilters(data.params.fields, data.params.customFields, data.params.filters)"
            >
                <span>
                    <i class="fal fa-sliders-h" />
                    {{ btnLabel }}
                </span>
            </button>

            <ui-button :design="download.design" @click="downloadReportHandler">
                <em :class="download.icon" />
            </ui-button>

            <ui-menu-card icon="fal fa-ellipsis-v" :disabled="disable">
                <button
                    v-if="showActions"
                    type="button"
                    @click="toggleFilters(data.params.fields, data.params.customFields, data.params.filters, 'edit')"
                >
                    Editar
                </button>
                <button v-if="showActions" type="button" @click="clearFields">
                    Limpar Campos
                </button>
                <button v-if="allowDiscard" type="button" @click="discardReport">
                    Descartar Relatório
                </button>
            </ui-menu-card>
        </div>
    </section>
</template>

<script>
import { uiButton } from "@/components/ui/buttons"
import { uiMenuCard } from '@/components/ui'

import { storage } from '@/services/storage'
import { reportsCategory } from '@/services/axios'

import { helpersMixin } from '@/mixins'

import { defaultFilters } from '@/assets/js/data.js'

export default {
    name: 'ui-report-card',

    components: {
        uiButton,
        uiMenuCard
    },

    mixins: [helpersMixin],

    props: {
        data: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },

    },

    data() {
        return {
            showFilters: false,
            showModalDownload: true,
            cvsXlsx: false,
            reports: [],
            btnLabel: 'Personalizar',
            download: {
                design: 'md primary',
                icon: 'fal fa-download'
            },
            disable: true,
            showActions: true,
            allowDiscard: false
        }
    },

    watch: {
        /**
         * Observa por mudanças nos dados do card atual
         */
        data: {
            handler() {
                this.handleFields(this.index)
            },
            deep: true
        }
    },

    created() {
        this.$root.$on(`${this.data.category}-save-fields-${this.index}`, () => {
            this.handleFields()
        })

        this.$root.$on(`${this.data.category}-clear-fields-${this.index}`, () => {
            this.clearFields()
        })

        // Manipula o evento quando um arquivo de relatório em status de espera é baixado
        this.$root.$on('download-csv-xlsx-modal-success', payload => {
            const storageKey = `${payload.category}_card_fields_${payload.index}`
            let storageData = storage.get(storageKey)
            storageData = storageData && this.isJSON(storageData) ? JSON.parse(storageData) : []
            const index = storageData.findIndex(item => item.fieldName === 'generating_file')
            if (index >= 0) storageData.splice(index, 1)
            storage.set(storageKey, JSON.stringify(storageData))
            this.handleFields()
        })
    },

    mounted() {
        this.handleFields()
    },

    beforeDestroy() {
        this.$root.$off(`${this.data.category}-save-fields-${this.index}`)
        this.$root.$off(`${this.data.category}-clear-fields-${this.index}`)
        this.$root.$off('download-csv-xlsx-modal-success')
    },

    methods: {
        /**
         * Solicita a abertura do menu para seleção de campos e filtros para gerar o relatório
         */
        toggleFilters(fields, customFields, filters, action='customize') {
            let event = null
            if (action === 'customize') {
                event = {
                    event: "fac_button_click",
                    category: "vue-relatorio-planilhas-new",
                    action: "click",
                    label: "Personalizar"
                }

            } else {
                event = {
                    event: "fac_button_click",
                    category: "vue-relatorio-planilhas-new",
                    action: "click",
                    label: "Editar"
                }
            }

            if (event) this.$gtm.trackEvent(event)

            const { fileName, title } = this.data
            const reportData = JSON.parse(storage.get('report_data'))
            const newData = { ...reportData, fileName }

			storage.set('report_data', JSON.stringify(newData) )
            this.$root.$emit('show-filters', fields, customFields, filters, this.data.category, this.index)
            this.$root.$emit('report-title', title)
        },
        /**
         * Abre o modal para download do relatório
         */
        handleStorageField(storageData){
            let fields = []
            let filters = []
            let customFields = []
            let filter = ''
            for (const item of storageData) {
                    switch (item.fieldName) {
                        case 'general':
                            fields = [...item.fields]
                            break

                        case 'customFields':
                            customFields = [...item.fields]
                            break
                    
                        default:
                            filter = [...defaultFilters()].find(filter => filter.name == item.fieldName);
                            if (filter) filters.push({ name: filter.label, value: [...item.fields] })
                            break
                    }
                }
            return { fields, filters, customFields }
        },

        downloadReportHandler: async function () {
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vue-relatorio-planilhas-new",
                action: "click",
                label: `Button Baixar CSV - ${this.data.fileName}`
            })

            // Carrega os dados do relatório atual
            let storageData = storage.get(`${this.data.category}_card_fields_${this.index}`)
            storageData = storageData && this.isJSON(storageData) ? JSON.parse(storageData) : []
            // Verifica se já existe uma versão deste relatório em processo de geração
            const index = storageData.findIndex(item => item.fieldName === 'generating_file')
            let report = null
            try {
                this.$root.$emit('modal-open-download-csv-xlsx')
                if (index >= 0) {
                    report = { ...storageData[index].report }

                } else {
                    // Formata os dados do localStorage para gerar o relatório requerido
                    let {fields, filters, customFields} = this.handleStorageField(storageData);
                    const reportData = JSON.parse(storage.get('report_data'))
                    reportData.fileName = this.data.fileName
                    const params = { ...reportData, fields, filters, customFields }
                    /**
                    * Determina se a requisição será feita no Data Lake com base na instância da empresa.
                    */
                    const getStorage = JSON.parse(storage.get('api_config'))
      			    const instance = getStorage.instance
                    const reportsCategoryInstance = await reportsCategory.defineVersionReports(instance)
                    const response = await reportsCategoryInstance.createV2('create', params)

                    report = {
                        name: response?.data?.data?.reportName,
                        csv: {
                            query_id: null,
                            url: ''
                        },
                        xls: {
                            job_id: null,
                            url: ''
                        },
                        status: 'generating'
                    }

                    if (response?.data?.data?.csvUrl) {
                        report.csv.url = response?.data?.data?.csvUrl
                        report.status = 'generated'

                    } else {
                        report.csv.query_id = response?.data?.data?.queryExecId
                    }
                   
                    storage.set(
                        `${this.data.category}_card_fields_${this.index}`,
                        JSON.stringify([...storageData, { fieldName: 'generating_file', report }])
                    )
                    this.handleFields()
                }
                this.$root.$emit(
                    'download-csv',
                    report,
                    { category: this.data.category, index: this.index }
                )

            } catch (error) {
                error.data.msg ? this.$toastr.e(error.data.msg) : this.$toastr.e('Falha ao gerar o contrato!') ;
                console.log(error)
                this.$root.$emit('modal-close-download-csv-xlsx')
            }
        },
        /**
         * Verifica quantos campos foram selecionados para o relatório em questão
         */
        handleFields() {
            const fields = storage.get(`${this.data.category}_card_fields_${this.index}`)
            let countFields = 0
            if (fields && this.isJSON(fields)) {
                const data = JSON.parse(fields)
                // Pega todos os filtros disponíveis
                const allFilters = [...defaultFilters()]
                // Pega os labels dos filtros requeridos para este relatório
                const requiredFilters = Object.values(this.data.params.filters).map(filter => filter.label)
                // Monta um array com os tipos de campo e nomes dos filtros utilizados
                const selectedData = [
                    'customFields',
                    'general',
                    ...allFilters.filter(item => requiredFilters.includes(item.label))
                        .map(item => item.name)
                ]
                countFields = data
                    .filter(item => selectedData.includes(item.fieldName))
                    .reduce((acm, item) => item.fields.length + acm, 0)

                // Define o ícone e cor do botão de download
                this.allowDiscard = false
                const generatingFile = data.find(item => item.fieldName === 'generating_file')
                if (generatingFile) {
                    if (generatingFile.report.status === 'generating') {
                        this.download.design = 'md warning'
                        this.download.icon = 'fal fa-hourglass'

                    } else if (generatingFile.report.status === 'generated') {
                        this.download.design = 'md success'
                        this.download.icon = 'fal fa-file-csv'
                        this.allowDiscard = true
                    }

                } else {
                    this.download.design = 'md primary'
                    this.download.icon = 'fal fa-download'
                }
            }

            const numFields = countFields < 10 ? `0${countFields}` : countFields
            this.btnLabel = countFields ? `${numFields} campos` : 'Personalizar'
            this.disable = countFields < 1
            this.showActions = !this.disable
            this.showFilters = countFields > 0
            // Caso exista uma versão gerada do relatórios, habilita o menu de ações
            if (this.allowDiscard) this.disable = false
        },
        /**
         * Trata o evento de quando a limpeza dos campos e filtros é requerida para o relatório
         */
        clearFields() {
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vue-relatorio-planilhas-new",
                action: "click",
                label: "Limpar Campos"
            })

            storage.remove(`${this.data.category}_card_fields_${this.index}`)
            storage.remove(`${this.data.category}_card_field_range_${this.index}`)
            this.handleFields()
        },
        /**
         * Descarta a versão gerada para o relatório atual
         */
        discardReport() {
            this.$gtm.trackEvent({
                event: "fac_button_click",
                category: "vue-relatorio-planilhas-new",
                action: "click",
                label: "Descartar Relatório"
            })

            this.$root.$emit(
                'download-csv-xlsx-modal-success',
                { category: this.data.category, index: this.index }
            )
        }
    }
}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>